import styled from 'styled-components';

export const SubscribeBarStyled = styled.div`
    /* Subscribe Now bar */
    .subscribe-bar {
        padding: 6px 4px;
        font-size: 14px;
        color: white;
        text-align: center;
        background: #389e0d;

        &.orange {
        background: #fa8c16;
        }

        &.red {
        background: #cf1322;
        }

        a {
        color: white;
        text-decoration: underline;
        }
    }
`;
